const ErrorType = {
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    START_END_DATES: 'START_END_DATES',
    TOO_MANY_RESULTS: 'TOO_MANY_RESULTS',
};

export default ErrorType;
